var _style, _g, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 425.2",
    style: {
      enableBackground: "new 0 0 566.9 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#163B29;}\n\t.st1{clip-path:url(#SVGID_00000067211509552145947630000012761321246758990270_);}\n\t.st2{fill:#A3D76C;}\n\t.st3{fill:#008250;}\n\t.st4{fill:#78C8B9;}\n\t.st5{fill:#009691;}\n\t.st6{fill:#C8E155;}\n\t.st7{fill:#00A54B;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.9,
    y: 353.8,
    className: "st0",
    width: 12.6,
    height: 57.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "287.5,353.8 272.1,353.8 254.6,376.7 250.6,376.7 250.6,353.8 238,353.8 238,411.2 250.6,411.2  250.6,387.4 254.6,387.4 272.2,411.2 288.3,411.2 265.5,381.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "234.6,353.8 219.2,353.8 201.6,376.7 197.7,376.7 197.7,353.8 185.1,353.8 185.1,411.2 197.7,411.2  197.7,387.4 201.6,387.4 219.3,411.2 235.4,411.2 212.5,381.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "163.7,389.9 139,353.8 127.1,353.8 127.1,411.2 139.1,411.2 139.1,375.9 163.8,411.2 175.6,411.2  175.6,353.8 163.7,353.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.1,353.8l-22,57.4h13.4l3.9-11.3h21.4l4,11.3h13.3l-21.6-57.4H89.1z M88.1,389.1l3.4-9.9 c0.7-2.1,1.5-4.4,2.3-6.9c0.4-1.3,0.8-2.6,1.2-3.8c0.4,1.4,0.9,2.8,1.3,4.1c0.8,2.5,1.6,4.7,2.2,6.6l3.4,9.9L88.1,389.1 L88.1,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,358.4c-3.7-3-9.8-4.5-18.2-4.5H25.9v57.4h12.6v-16.8h8.2c7.9,0,13.8-1.7,17.7-5.1 c3.8-3.4,5.9-8.7,5.9-15.8S68.3,361.4,64.6,358.4 M55,380.9c-1.6,1.4-4.5,2.2-8.6,2.2h-7.9v-17.7h7.9c4.2,0,7.1,0.6,8.7,1.9 s2.3,3.3,2.3,6.3C57.4,377,56.6,379.5,55,380.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.2,187.2c12.5,2.9,10.8,7.1,15.6,32.5c1.4,6,4.9,8.3,10.5,8.3c6.5,0,18.5-4,18.5-15.1 c0-14.5-7.7-32.2-44.7-32.2c-28.8,0-47.2,15.1-47.2,40.9c0,19.8,14,34.5,36.2,43.3c17.3,6.9,26.6,14,26.6,26.6 c0,13.7-9,19.5-20.3,19.5c-17.3,0-32.1-21.4-38.1-42.8h-5.8l2.4,30.4c0.4,5.9,4.1,11,9.5,13.3c8.8,3.6,20.4,5.5,30.6,5.5 c29.9,0,50.8-15.4,50.8-42c0-22.2-13.7-33.9-37-43c-15.9-6-27.2-12.7-27.2-26.1C351.7,194.6,359.4,184.5,371.2,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.7,304.2c-4.2-1.7-7.1-5.4-7.1-21.2v-63.7c0-16.5-4.6-38.8-50.4-38.8c-37,0-61.1,17.7-61.1,32.2 c0,11.1,12,15.1,18.5,15.1c5.7,0,9.1-2.3,10.5-8.3c4.8-25.4,17.5-32.5,28.6-32.5c11.4,0,18.8,8.3,18.8,25.9v23.5l1.6,46 c0,15.6-10.9,19.5-17.6,19.5c-13.7,0-21.2-13.7-21.2-29.5c0-12.5,3.6-19.2,13.4-23.7c6-3.3,12.2-6.5,17.5-9.1l-0.1-3.1v-4 c-10,5.2-27.6,10.1-42.8,14.1c-21.3,6-27.3,17-27.3,31.5c0,20.2,11.9,38.9,38.7,38.9c17,0,29-11.4,38.4-17.3 c2.3,9.9,7.1,17.3,20.5,17.3c13.4,0,23.3-2.8,31.5-7.7V305C552.7,305.3,548.8,305.3,545.7,304.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.1,173.3c11.5,0,18.5-8.1,18.5-18.5c0-9.8-6.7-18.2-18.2-18.2c-11.8,0-18.5,8.4-18.5,18.2 C266.9,165.2,273.6,173.3,285.1,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.7,297.4V186.2l-1.1-0.8l-48.3,7.4v5.8l7.6,1.1c4.9,0.8,6.8,2.7,6.8,13v84.6c0,10-1,12.2-9.8,13.2 c-4.2,0.4-8.4,0.4-12.6,0c-9-0.9-9.8-3.1-9.8-12.9V136.9l-0.3-0.3l-50.7,5v5.6l9.2,1.4c4.8,0.8,6.7,3.4,6.7,14v135 c0,7.9-0.5,10.8-5.3,12.2c-2.6,0.7-5.4,0.7-8-0.1c-5.3-1.5-7.5-4.9-10.4-12.3c-12.8-35.4-42.2-119.3-55.9-160.8H91.3 c-16.2,49-46.1,131.8-57,157.4c-5.9,13.6-8.4,16.1-23.5,17v6.1h59V311l-15.4-1.1c-6.4-0.8-7.5-4.2-5.3-12.5 c3.3-15.5,8.6-29.4,14.5-48.8h48.6c-0.9-2.9-1.9-6.1-3-9.6H66.4c5.1-17.7,19.7-58.7,24.2-73.3h0.8c3.1,9.4,41.2,120.3,45.4,133.6 c2.2,6.1,1.1,9.7-5,10l-14.3,1.6v6.1h201.1v-6C303.8,310.2,302.7,309.3,302.7,297.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M418,15l-49.7,28.7c-2.1,1.2-3.5,3.5-3.5,6v57.4c0,2.5,1.3,4.8,3.5,6l49.7,28.7c2.2,1.3,4.8,1.3,7,0 l49.7-28.7c2.1-1.2,3.5-3.5,3.5-6V49.7c0-2.5-1.3-4.8-3.5-6L425,15C422.8,13.7,420.1,13.7,418,15"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047052876101821435710000001825585066934515108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047052876101821435710000001825585066934515108_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "421.5,-2.1 421.5,78.4 349.4,38.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "421.5,78.4 421.5,158.8 349.4,118.6  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "493.6,38.2 493.6,118.6 421.5,78.4  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "493.6,118.6 421.5,78.4 421.5,158.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "493.6,38.2 421.5,-2.1 421.5,78.4  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "421.5,78.4 349.4,38.2 349.4,118.6  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFef);
export default __webpack_public_path__ + "static/media/FEF.fd510a6201b7cc8f0f09d069571fd87d.svg";
export { ForwardRef as ReactComponent };